import React from 'react';
import './Sidebar.scss';

export default function Sidebar({
  sideBarItems,
  selectedIndex,
  setSelectedIndex,
}) {
  return (
    <div className='sidebar'>
      <div className='gdp-side-items'>
        <h1>Key Statistics</h1>
        <ul className='gdp_side-items__lists'>
          {sideBarItems.map((item, index) => (
            <li
              className={selectedIndex === index ? 'active' : ''}
              onClick={() => setSelectedIndex(index)} //set item title...
              key={index}
            >
              {item?.code}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
